export const GeneratePasswordBarcode = async () => {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    try {
        const response = await fetch(`${ApiURL}User/generatePasswordBarcode`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
        });
        const responseData = await response.json();
        if (response.status === 200 && responseData.success === true) {
            return { data: responseData.data, isSuccess: true, error: null };
        } else {
            return { data: null, isSuccess: false, error: "An error occurred during the fetch" };
        }
    } catch (error) {
        console.error("An error occurred during the fetch:", error);
        return { data: null, isSuccess: false, error: error };
    }
};


export const GetAllUserData = async (usercode) => {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    try {
        const response = await fetch(`${ApiURL}User/search/${usercode}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
        });
        const responseData = await response.json();
        if (response.status === 200 && responseData.success === true) {
            return { data: responseData.data[0], isSuccess: true, error: null };
        } else {
            return { data: {}, isSuccess: false, error: responseData.msg };
        }
    } catch (error) {
        console.error("An error occurred during the fetch:", error);
        return { data: {}, isSuccess: false, error: error };
    }
};




export const UpdatePersonalDetails = async (JsonObj) => {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    try {
        const response = await fetch(`${ApiURL}User/update_personal_Details`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: JSON.stringify(JsonObj)
        });
        const responseData = await response.json();
        if (response.status === 200 && responseData.success === true) {
            return { data: responseData.msg, isSuccess: true, error: null };
        } else {
            return { data: responseData.msg, isSuccess: false, error: responseData.msg };
        }
    } catch (error) {
        console.error("An error occurred during the fetch:", error);
        return { data: error, isSuccess: false, error: error };
    }
};




export const UpdatePersonalPassword = async (JsonObj) => {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    try {
        const response = await fetch(`${ApiURL}User/update_user_passwrod`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: JSON.stringify(JsonObj)
        });
        const responseData = await response.json();
        if (response.status === 200 && responseData.success === true) {
            return { data: responseData.msg, isSuccess: true, error: null };
        } else {
            return { data: responseData.msg, isSuccess: false, error: responseData.msg };
        }
    } catch (error) {
        console.error("An error occurred during the fetch:", error);
        return { data: error, isSuccess: false, error: error };
    }
};